import {
  type IJointBillServicePeriodData,
  type IOverviewJointBillService,
} from "@services/overview/types";

export interface ICreateJointBillServiceRequest {
  displayName?: string;
  orderNumber?: number;
  firstName: string;
  lastName: string;
  municipalityId?: number;
  settlementId?: number;
  streetId?: number;
  houseNumber?: string;
  apartmentNumber?: string;
  jointBillServiceTypeId?: JointBillServiceTypeId;
  area?: number;
  heatingTypeId?: HeatingTypeId;
}

export interface IEditJointBillServiceRequest {
  address?: {
    municipalityId: number;
    settlementId: number;
    streetId: number;
    houseNumber: string;
    apartmentNumber?: string;
  };
  sortOrderAndDisplayName: {
    displayName?: string;
    orderNumber?: number;
  };
  jointBillServiceInformation: {
    firstName: string;
    lastName: string;
    jointBillServiceTypeId?: JointBillServiceTypeId;
    area?: number;
    heatingTypeId?: HeatingTypeId;
  };
}

export interface IDeleteJointBillServiceRequest {
  jointBillServiceId: number;
}

export interface IPeriod {
  periodId: number;
  year: number;
  month: number;
}

export interface IJointBillServicePeriodList {
  jointBillServiceId: number;
  periods: IPeriod[];
}

export interface IJointBillServicePeriodList {
  jointBillServiceId: number;
  periods: IPeriod[];
}

export interface IJointBillServicePdfRequest {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
  periodId: number;
}

export interface IFile {
  data: string;
  fileName: string;
  contentType?: string;
}

export enum JointBillServiceTypeId {
  APARTAMENT = "APA",
  COMMERCIAL = "COM",
  COTTAGE = "COT",
  HOUSE = "HOU",
  LAND_AREA = "LAN",
}

export enum HeatingTypeId {
  ELECTRICITY = "EC",
  GAS = "GAS",
  CENTRALIZED = "CEN",
  OTHER = "OTH",
}

export interface IJointBillServiceEditData {
  jointBillServiceId: 774946;
  isOwner: boolean;
  firstName: string;
  lastName: string;
  address: {
    municipalityId: number;
    municipalityName?: string;
    settlementId: number;
    settlementName?: string;
    streetId: number;
    streetName?: string;
    houseNumber?: string;
    apartmentNumber?: string;
  };
  addressIsEditable: boolean;
  jointBillServiceTypeId: JointBillServiceTypeId;
  heatingTypeId: HeatingTypeId;
  area: number;
  displayName: string;
  sortOrder: number;
}

export interface IOpenJointBillServiceCurrentPeriodRequestData {
  jointBillServiceId: IJointBillServicePeriodData["jointBillServiceId"];
  periodId: number;
}

export interface IBookletRequest {
  url: string;
}

export interface IBooklet {
  data: string;
  fileName: string;
}

export interface ITransferPreviousExpectedPaymentsRequest {
  billId: number;
  // Only used for cache invalidation
  jointBillServiceId: number;
  periodId: number;
}
